import * as EmailValidator from 'email-validator';

export const validateEmail = email => {
    if (typeof email !== 'string') {
        throw 'Email is not a string';
    }

    const validEmail = EmailValidator.validate(email);

    if (!validEmail) {
        throw `Invalid email: ${email}`;
    }
};

export const validateTemplateBindings = (allRegex, validRegex, value, bindings = null) => {
    // Check for any possible bindings in the modelValue by the passed regex
    const allBindings = [
        ...value.matchAll(allRegex)
    ];

    let invalidTokens = [];

    if (bindings) {
        // Get the keys of the bindings object as {{key}}
        const bindingKeys = Object.keys(bindings);

        // Run through all the dynamic bindings and check if they are valid
        invalidTokens = allBindings.filter((binding) =>
            !binding[0].match(validRegex) ||
            (binding[0].match(validRegex) && !bindingKeys.includes(binding[0]))
        );
    } else {
        invalidTokens = allBindings.map((binding) => binding[0]);
    }

    if (invalidTokens.length > 0) {
        return {
            valid: false,
            errors: invalidTokens
        };
    }

    return {
        valid: true,
        errors: []
    };
};
